import { React } from 'Imports';
import { TextField, InputAdornment, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { isEncompass } from '$Utilities/integrationPlatform';
import * as scssStyles from '$CSS/settings.scss';
import { useState } from 'react';

const styles = require('$Components/FilterComponents/Filters/SearchField.scss') as {
    searchFieldGeotab: string;
    searchFieldEncompass: string;
    closeIcon: string;
    inputAdorment: string;
};

interface IFilterBarSearchFieldProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    onClear: () => void;
    placeholder?: string;
    isMobileView?: boolean;
}

const SearchField = (props: IFilterBarSearchFieldProps) => {
    const [isFocused, setIsFocused] = useState(false);
    const isFiltering = props.value.length > 0;

    const showSearchIcon = isEncompass && !isFocused && !isFiltering;
    const fixedWith = props.isMobileView ? '100%' : isEncompass ? '270px' : '230px';

    return (
        <Box
            sx={{
                maxHeight: isEncompass ? '32px' : '40px',
                height: isEncompass ? '32px' : '40px',
                width: props.isMobileView ? '100%' : 'auto',
            }}
        >
            <TextField
                variant="outlined"
                value={props.value}
                onChange={(e) => props.onChange(e.target.value)}
                placeholder={isFocused ? '' : props.placeholder || props.label}
                fullWidth={props.isMobileView}
                className={isEncompass ? styles.searchFieldEncompass : styles.searchFieldGeotab}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                sx={{
                    minWidth: fixedWith,
                    maxWidth: fixedWith,
                    margin: 0,
                    fontWeight: 400,
                    fontSize: isEncompass ? '12px' : '14px',
                    fieldset: {
                        border: isFocused
                            ? isEncompass
                                ? '1px solid #0D7AC5 !important'
                                : '1px solid #25477B !important'
                            : isEncompass
                              ? '1px solid #C4CBD4 !important'
                              : '1px solid #C4CBD7 !important',
                    },
                }}
                InputProps={{
                    sx: {
                        textAlign: 'left',
                        height: isEncompass ? '32px' : '40px',
                        padding: isEncompass ? '0px 12px' : '0px 16px',
                    },
                    startAdornment: showSearchIcon ? (
                        <InputAdornment position="start">
                            <FontAwesomeIcon icon={faSearch} color={scssStyles.searchMagnifyingGlassColor} />
                        </InputAdornment>
                    ) : null,
                    endAdornment: isFiltering ? (
                        <InputAdornment position="end" onClick={props.onClear} className={styles.inputAdorment} sx={{ cursor: 'pointer' }}>
                            <FontAwesomeIcon icon={faXmark} color={scssStyles.searchFieldXmarkColor} className={styles.closeIcon} />
                        </InputAdornment>
                    ) : null,
                }}
            />
        </Box>
    );
};

export default SearchField;
